import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingDown } from 'lucide-react';
import { IntelligenceCard, IntelligenceCardStatus } from './IntelligenceCard';
import { useClassPerformance } from '@/hooks/useClassPerformance';

export const ClassPerformanceCard: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading, error } = useClassPerformance();

  const getStatus = (count: number): IntelligenceCardStatus => {
    if (count === 0) return 'success';
    if (count <= 1) return 'warning';
    return 'danger';
  };

  const handleReviewClasses = () => {
    navigate('/admin/classes', { 
      state: { 
        filterUnderperforming: true 
      } 
    });
  };

  const count = data?.count || 0;
  const status = getStatus(count);

  const getContextText = () => {
    if (count === 0) {
      return "All classes performing well! 🎯";
    }
    
    if (count === 1) {
      const classData = data?.underperforming_classes[0];
      return `${classData?.class_name}: ${classData?.attendance_rate}% attendance, ${classData?.enrollment_count} students`;
    }
    
    return `${count} classes need attention for better engagement`;
  };

  const getStatusText = () => {
    if (count === 0) return 'All performing well';
    if (count === 1) return '1 class needs attention';
    return `${count} classes need attention`;
  };

  return (
    <IntelligenceCard
      title="Class Performance Watchlist"
      description="Classes with performance issues"
      icon={TrendingDown}
      metric={count}
      metricLabel={count === 1 ? "underperforming class" : "underperforming classes"}
      contextText={getContextText()}
      status={status}
      statusText={getStatusText()}
      actionLabel="Review Classes"
      onAction={handleReviewClasses}
      actionDisabled={count === 0}
      isLoading={isLoading}
      error={error?.message}
    />
  );
};